import { render, staticRenderFns } from "./serviceRecord.vue?vue&type=template&id=edccb9cc&scoped=true"
import script from "./serviceRecord.vue?vue&type=script&lang=js"
export * from "./serviceRecord.vue?vue&type=script&lang=js"
import style0 from "./serviceRecord.vue?vue&type=style&index=0&id=edccb9cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edccb9cc",
  null
  
)

export default component.exports